import { cnpj } from 'cpf-cnpj-validator'

import { requiredBillingAddressTypes } from './constants'
import { creditCardDTO } from './creditCardDTO'
import { normalizeNumbers } from './utils'

export const rechargeDTO = (data: RechargeDTOData): IndustryRecharge => {
  const {
    publisher_id,
    amount,
    payment_method,
    name,
    phone,
    email,
    card_cvv,
    card_expiration,
    card_name,
    card_number,
    card_brand,
    card_token,
    installments,
    identificationNumber
  } = data

  const identification = identificationNumber

  const industryRecharge: IndustryRecharge = {
    publisher_id,
    amount: Number(amount),
    payment_method,
    customer: {
      name,
      social_id: cnpj.strip(identification),
      phone: normalizeNumbers(phone || ''),
      email
    }
  }

  if (requiredBillingAddressTypes.includes(payment_method)) {
    const {
      city,
      complement,
      neighborhood,
      number,
      postcode,
      region,
      street,
      country = 'unknown'
    } = data.billingAddress

    const payloadAddress = {
      city,
      complement,
      neighborhood,
      number,
      postcode: normalizeNumbers(postcode || ''),
      region,
      street,
      country
    }

    industryRecharge.billing_address = payloadAddress
  }

  if (payment_method === 'credit_card') {
    industryRecharge.installments = Number(installments || 1)

    const payloadCreditCard = {
      card_token,
      card_cvv,
      card_expiration,
      card_name,
      card_number,
      card_brand: card_brand
    }

    industryRecharge.credit_card = creditCardDTO(payloadCreditCard)
  }

  return industryRecharge
}
